<template>
<svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20.0007 37.5736C29.2054 37.5736 36.6673 30.1116 36.6673 20.9069C36.6673 11.7022 29.2054 4.24023 20.0007 4.24023C10.7959 4.24023 3.33398 11.7022 3.33398 20.9069C3.33398 30.1116 10.7959 37.5736 20.0007 37.5736Z" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M20 14.2402V20.9069" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M20 27.5737H20.0167" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>
